import React from "react";

import {
  Button,
  Header,
  Icon,
  Label,
  Message,
  Progress,
  Segment,
} from "semantic-ui-react";

const EstadoTenant = ({
  empresa,
  usuariosActivos = 0,
  adminHomeCare = null,
  loadingAdmin = false,
  onCrearAdministrador,
}) => {
  if (!empresa) return null;

  // ============================================================
  // DATOS TENANT
  // ============================================================

  const maxUsers =
    Number(
      empresa.maxUsers ||
        empresa.maxusuarios ||
        empresa.max_usuarios ||
        1
    ) || 1;

  const porcentajeUsuarios = Math.min(
    (usuariosActivos / maxUsers) * 100,
    100
  );

  const tenantActivo =
    String(empresa.estado || "").toUpperCase() === "ACTIVA";

  const contratoMantencion =
    empresa.contrato_mantencion === true;

  const usaLogisticMedST =
    empresa.usa_logisticmed_st === true;

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <Segment
      style={{
        marginTop: 18,
        padding: 0,
        borderRadius: 10,
        border: "1px solid #e5e9ef",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        overflow: "hidden",
      }}
    >
      {/* ===================================================== */}
      {/* HEADER */}
      {/* ===================================================== */}

      <div
        style={{
          padding: "15px 18px",
          borderBottom: "1px solid #edf0f4",
          display: "flex",
          alignItems: "center",
          gap: 12,
          background: "#ffffff",
        }}
      >
        <div
          style={{
            width: 42,
            height: 42,
            minWidth: 42,
            borderRadius: 10,
            background: "#e5f7f7",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon
            name="server"
            style={{
              margin: 0,
              fontSize: 18,
              color: "#0d9da5",
            }}
          />
        </div>

        <div>
          <Header
            as="h3"
            style={{
              margin: 0,
              color: "#172b4d",
              fontWeight: 700,
            }}
          >
            Salud del Tenant
          </Header>

          <div
            style={{
              marginTop: 3,
              color: "#8793a5",
              fontSize: 12,
            }}
          >
            Resumen comercial, operacional y administrativo
          </div>
        </div>
      </div>

      {/* ===================================================== */}
      {/* CARDS */}
      {/* ===================================================== */}

      <div
        style={{
          padding: 18,
          background: "#f8fafc",
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit, minmax(290px, 1fr))",
          gap: 14,
        }}
      >
        {/* =================================================== */}
        {/* ESTADO GENERAL */}
        {/* =================================================== */}

        <div style={cardStyle}>
          <SectionTitle
            icon="building outline"
            color="#2185d0"
            title="Estado general"
          />

          <EstadoFila
            titulo="Tenant"
            valor={empresa.estado || "SIN ESTADO"}
            color={tenantActivo ? "green" : "orange"}
          />

          <EstadoFila
            titulo="Plan"
            valor={empresa.plan || "BASICO"}
            color="blue"
          />

          <EstadoFila
            titulo="Contrato mantención"
            valor={contratoMantencion ? "ACTIVO" : "NO"}
            color={contratoMantencion ? "green" : "grey"}
          />

          <EstadoFila
            titulo="LogisticMed ST"
            valor={usaLogisticMedST ? "HABILITADO" : "NO"}
            color={usaLogisticMedST ? "teal" : "grey"}
            ultimo
          />
        </div>

        {/* =================================================== */}
        {/* CAPACIDAD */}
        {/* =================================================== */}

        <div style={cardStyle}>
          <SectionTitle
            icon="users"
            color="#6435c9"
            title="Capacidad del tenant"
          />

          <div
            style={{
              paddingTop: 18,
            }}
          >
            <Progress
              percent={Math.round(porcentajeUsuarios)}
              progress
              indicating
              size="small"
            >
              Usuarios: {usuariosActivos} / {maxUsers}
            </Progress>
          </div>

          <div
            style={{
              marginTop: 18,
            }}
          >
            <EstadoFila
              titulo="Usuarios activos"
              valor={`${usuariosActivos} / ${maxUsers}`}
              color={
                usuariosActivos >= maxUsers
                  ? "orange"
                  : "green"
              }
            />

            <EstadoFila
              titulo="Logo"
              valor={
                empresa.logoUrl
                  ? "CONFIGURADO"
                  : "SIN LOGO"
              }
              color={
                empresa.logoUrl
                  ? "green"
                  : "orange"
              }
              ultimo
            />
          </div>
        </div>

        {/* =================================================== */}
        {/* ADMINISTRADOR HOMECARE */}
        {/* =================================================== */}

        <div style={cardStyle}>
          <SectionTitle
            icon="user circle"
            color="#0d9da5"
            title="Administrador HomeCare"
          />

          {loadingAdmin ? (
            <div
              style={{
                minHeight: 150,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#8793a5",
              }}
            >
              <Icon
                loading
                name="spinner"
                style={{
                  color: "#0d9da5",
                }}
              />

              Consultando administrador...
            </div>
          ) : adminHomeCare ? (
            <>
              {/* ADMIN EXISTENTE */}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  padding: "17px 0",
                }}
              >
                <div
                  style={{
                    width: 44,
                    height: 44,
                    minWidth: 44,
                    borderRadius: "50%",
                    background:
                      adminHomeCare.activo === false
                        ? "#fdecec"
                        : "#eaf8ee",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Icon
                    name="user"
                    style={{
                      margin: 0,
                      color:
                        adminHomeCare.activo === false
                          ? "#db2828"
                          : "#21ba45",
                    }}
                  />
                </div>

                <div
                  style={{
                    minWidth: 0,
                  }}
                >
                  <div
                    style={{
                      color: "#344563",
                      fontWeight: 700,
                    }}
                  >
                    {`${adminHomeCare.nombre || ""} ${
                      adminHomeCare.apellido || ""
                    }`.trim() || "Administrador HomeCare"}
                  </div>

                  <div
                    style={{
                      color: "#8793a5",
                      fontSize: 12,
                      marginTop: 3,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={adminHomeCare.correo || ""}
                  >
                    {adminHomeCare.correo || "-"}
                  </div>
                </div>
              </div>

              <EstadoFila
                titulo="Rol"
                valor="ADMIN-HC"
                color="blue"
              />

              <EstadoFila
                titulo="Estado"
                valor={
                  adminHomeCare.activo === false
                    ? "BLOQUEADO"
                    : "ACTIVO"
                }
                color={
                  adminHomeCare.activo === false
                    ? "red"
                    : "green"
                }
              />

              <EstadoFila
                titulo="Origen"
                valor={
                  adminHomeCare.origen || "REGISTRO"
                }
                color="teal"
                ultimo
              />

              {adminHomeCare.activo === false && (
                <Message
                  warning
                  size="small"
                  style={{
                    marginTop: 14,
                    boxShadow: "none",
                  }}
                >
                  <Icon
                    name="warning sign"
                    color="orange"
                  />

                  El tenant posee un ADMIN-HC, pero se encuentra bloqueado.
                  No corresponde crear otro administrador inicial.
                </Message>
              )}
            </>
          ) : (
            <>
              {/* SIN ADMINISTRADOR */}

              <Message
                warning
                size="small"
                style={{
                  marginTop: 16,
                  boxShadow: "none",
                }}
              >
                <Icon
                  name="warning sign"
                  color="orange"
                />

                Este tenant todavía no posee un administrador HomeCare.
              </Message>

              <Button
                fluid
                type="button"
                onClick={onCrearAdministrador}
                style={{
                  marginTop: 14,
                  background: "#0d9da5",
                  color: "#ffffff",
                  borderRadius: 6,
                  boxShadow: "none",
                }}
              >
                <Icon
                  name="user plus"
                  style={{
                    color: "#ffffff",
                  }}
                />

                Crear Administrador HomeCare
              </Button>

              <div
                style={{
                  marginTop: 10,
                  color: "#8793a5",
                  fontSize: 11,
                  textAlign: "center",
                }}
              >
                El rol y la empresa serán asignados automáticamente.
              </div>
            </>
          )}
        </div>
      </div>
    </Segment>
  );
};

// ============================================================
// TITULO CARD
// ============================================================

const SectionTitle = ({
  icon,
  color,
  title,
}) => {
  return (
    <div
      style={{
        paddingBottom: 11,
        marginBottom: 2,
        borderBottom: "1px solid #edf0f4",
        display: "flex",
        alignItems: "center",
        gap: 8,
        color: "#253858",
        fontSize: 13,
        fontWeight: 700,
      }}
    >
      <Icon
        name={icon}
        style={{
          margin: 0,
          color,
        }}
      />

      {title}
    </div>
  );
};

// ============================================================
// FILA
// ============================================================

const EstadoFila = ({
  titulo,
  valor,
  color = "grey",
  ultimo = false,
}) => {
  return (
    <div
      style={{
        minHeight: 44,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 12,
        borderBottom: ultimo
          ? "none"
          : "1px solid #edf0f4",
      }}
    >
      <span
        style={{
          color: "#697586",
          fontSize: 12,
        }}
      >
        {titulo}
      </span>

      <Label
        basic
        color={color}
        size="tiny"
      >
        {valor || "-"}
      </Label>
    </div>
  );
};

// ============================================================
// CARD STYLE
// ============================================================

const cardStyle = {
  background: "#ffffff",
  border: "1px solid #e5e9ef",
  borderRadius: 8,
  padding: 16,
  boxShadow: "0 2px 5px rgba(0,0,0,0.03)",
  minHeight: 250,
};

export default EstadoTenant;